import { useMemo } from 'react';
import { IAdvantage, optionToAdvantage } from '@cp/entities/advantage';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { catalogOptionCoreApi } from '@cp/entities/catalogOption';
import { useAdvantagesPickedFromData } from '@cp/entities/resume';

export const useCatalogItemAdvantages = (catalogItem?: CatalogItemViewModel): IAdvantage[] => {
  const { data: allOptions } = catalogOptionCoreApi.endpoints.getOptions.useQuery(
    { careerId: catalogItem?.careerId as number, active: true },
    { skip: !catalogItem },
  );
  const dataAdvantages = useAdvantagesPickedFromData(catalogItem);

  return useMemo(() => {
    const advantages: IAdvantage[] = [];
    for (const dataAdvantage of dataAdvantages) {
      advantages.push({
        title: dataAdvantage.label,
        icon: dataAdvantage.renderIcon(),
        name: '',
      });
    }

    if (!allOptions || !catalogItem) {
      return advantages;
    }
    const optionsSet = new Set<number>();
    for (const option of catalogItem.options) {
      optionsSet.add(option.id);
    }
    for (const optionViewModel of allOptions.items.filter((option) => optionsSet.has(option.id))) {
      advantages.push(optionToAdvantage(optionViewModel));
    }
    return advantages;
  }, [catalogItem, allOptions, dataAdvantages]);
};
